function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value))
}

export function calculateViewportCenter(canvas, zoom) {
    const sizeX = Math.max(canvas.maxX - canvas.minX, 1)
    const sizeY = Math.max(canvas.maxY - canvas.minY, 1)

    return {
        x: -canvas.minX * zoom + (canvas.width - sizeX * zoom) / 2,
        y: -canvas.minY * zoom + (canvas.height - sizeY * zoom) / 2,
    }
}

export function calculateViewportFit(canvas, options = {}) {
    const { fitHeight = true, paddingRatio = 0.95, rightInset = 0 } = options
    const viewport = { ...canvas, width: Math.max(1, canvas.width - rightInset) }
    const sizeX = Math.max(canvas.maxX - canvas.minX, 1)
    const sizeY = Math.max(canvas.maxY - canvas.minY, 1)
    const widthRatio = viewport.width / sizeX
    const heightRatio = canvas.height / sizeY
    const desiredZoom = (fitHeight ? Math.min(widthRatio, heightRatio) : widthRatio) * paddingRatio
    const zoom = clamp(desiredZoom, canvas.zoom.min, canvas.zoom.max)
    const center = calculateViewportCenter(viewport, zoom)

    return {
        zoom,
        x: center.x,
        y: fitHeight ? center.y : 0,
    }
}
